// extracted by mini-css-extract-plugin
export default {"container":"TabNav__container___rseyR","tab":"TabNav__tab___b3uv1 fonts__whitney-semibold___M7vMo","selected":"TabNav__selected___PsttE"};